/* Warm Style — product page behaviour. No dependencies. */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    const fmt = format || window.wsMoneyFormat || '{{amount_with_comma_separator}} €';
    const n = (v, p = 2, t = ',', d = '.') => {
      if (isNaN(v) || v == null) return '0';
      const parts = (v / 100).toFixed(p).split('.');
      return parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + t) + (parts[1] ? d + parts[1] : '');
    };
    const m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    const key = m ? m[1] : 'amount';
    const map = {
      amount: n(cents, 2), amount_no_decimals: n(cents, 0),
      amount_with_comma_separator: n(cents, 2, '.', ','), amount_no_decimals_with_comma_separator: n(cents, 0, '.', ','),
      amount_with_space_separator: n(cents, 2, ' ', ','), amount_with_apostrophe_separator: n(cents, 2, "'", '.')
    };
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, map[key] ?? map.amount);
  }
  const money = c => formatMoney(Math.round(c));

  /* ---------------- MAIN PRODUCT ---------------- */
  class WsMain {
    constructor(root) {
      this.root = root;
      this.product = JSON.parse($('[data-ws-product-json]', root).textContent);
      this.cfg = JSON.parse($('[data-ws-config]', root).textContent);
      this.form = $('form.ws-form', root);
      if (!this.form) { console.warn('[WS] Ajoutez le bloc « Bouton d’achat » à la section produit.'); return; }
      this.idInput = $('[data-ws-id]', this.form) || $('input[name="id"]', this.form);
      this.qtyInput = $('[data-ws-qty]', this.form);
      this.upIdInput = $('[data-ws-up-id]', this.form);
      this.upQtyInput = $('[data-ws-up-qty]', this.form);
      this.qty = 1;
      this.tierDiscount = 0;
      this.variant = this.product.variants.find(v => v.id == this.idInput.value) || this.product.variants[0];
      this.initGallery();
      this.initOptions();
      this.initBundles();
      this.initUpsell();
      this.initAtc();
      this.initSticky();
      this.initTimers();
      this.initModals();
      this.initExit();
      this.render();
    }

    /* Gallery: scroll-snap track, thumbs, arrows, dots */
    initGallery() {
      this.track = $('[data-ws-track]', this.root);
      if (!this.track) return;
      this.slides = $$('[data-ws-slide]', this.track);
      this.thumbs = $$('[data-ws-thumb]', this.root);
      this.dots = $$('[data-ws-dot]', this.root);
      this.thumbRow = $('[data-ws-thumbs]', this.root);
      this.current = 0;
      this.thumbs.forEach((t, i) => t.addEventListener('click', () => this.goSlide(this.visible().indexOf(this.slides[i]))));
      $('[data-ws-prev]', this.root)?.addEventListener('click', () => this.goSlide(this.current - 1));
      $('[data-ws-next]', this.root)?.addEventListener('click', () => this.goSlide(this.current + 1));
      const io = new IntersectionObserver(es => es.forEach(e => {
        if (e.isIntersecting && e.intersectionRatio > .6 && !e.target.hidden) this.setActive(e.target);
      }), { root: this.track, threshold: [.6] });
      this.slides.forEach(s => io.observe(s));
      // media filter by colour (alt text)
      if (this.cfg.filterMedia) {
        const names = (this.cfg.filterNames || []).map(s => s.trim());
        this.filterIdx = (this.product.options || []).findIndex(o => names.includes(String(o.name || o).toLowerCase().trim()));
        if (this.filterIdx > -1) this.filterValues = [...new Set(this.product.variants.map(v => String(v.options[this.filterIdx]).toLowerCase().trim()))];
      }
      this.filterMedia(true);
    }
    visible() { return (this.slides || []).filter(s => !s.hidden); }
    goSlide(i) {
      const v = this.visible(); if (!v.length || i < -1) return;
      i = (i + v.length) % v.length;
      this.track.scrollTo({ left: v[i].offsetLeft, behavior: 'smooth' });
      this.setActive(v[i]);
    }
    setActive(slide) {
      const idx = this.slides.indexOf(slide);
      this.current = this.visible().indexOf(slide);
      this.thumbs.forEach((t, i) => t.setAttribute('aria-current', i === idx));
      this.dots.forEach((t, i) => t.setAttribute('aria-current', i === idx));
      const t = this.thumbs[idx], row = this.thumbRow;
      if (t && row) row.scrollTo({ left: t.offsetLeft - (row.clientWidth - t.offsetWidth) / 2, behavior: 'smooth' });
    }
    filterMedia(initial) {
      if (!this.slides || this.filterIdx == null || this.filterIdx < 0) return;
      const val = String(this.variant.options[this.filterIdx] || '').toLowerCase().trim();
      const tagged = s => this.filterValues.includes(s.dataset.alt);
      if (!this.slides.some(s => s.dataset.alt === val)) { this.slides.forEach((s, i) => { s.hidden = false; if (this.thumbs[i]) this.thumbs[i].hidden = false; if (this.dots[i]) this.dots[i].hidden = false; }); return; }
      this.slides.forEach((s, i) => {
        const show = !tagged(s) || s.dataset.alt === val;
        s.hidden = !show; if (this.thumbs[i]) this.thumbs[i].hidden = !show; if (this.dots[i]) this.dots[i].hidden = !show;
      });
      const first = this.slides.find(s => !s.hidden && s.dataset.alt === val) || this.visible()[0];
      if (first) { this.track.scrollTo({ left: first.offsetLeft, behavior: initial ? 'auto' : 'smooth' }); this.setActive(first); }
    }
    showMedia(mediaId) {
      if (!mediaId || !this.slides) return;
      const s = this.slides.find(s => s.dataset.mediaId == mediaId && !s.hidden);
      if (s) this.goSlide(this.visible().indexOf(s));
    }

    /* Variant options */
    initOptions() {
      this.optionInputs = $$('[data-ws-option] input', this.root);
      this.optionInputs.forEach(inp => inp.addEventListener('change', () => this.onOptionChange()));
    }
    selectedOptions() {
      return $$('[data-ws-option]', this.root).map(fs => ($('input:checked', fs) || {}).value);
    }
    onOptionChange() {
      const sel = this.selectedOptions();
      const v = this.product.variants.find(v => v.options.every((o, i) => sel[i] == null || o === sel[i]));
      if (!v) return;
      this.variant = v;
      this.idInput.value = v.id;
      this.filterMedia();
      if (v.featured_media) this.showMedia(v.featured_media.id);
      if (this.cfg.updateUrl) {
        const url = new URL(location.href); url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url);
      }
      this.render();
    }
    markAvailability() {
      const groups = $$('[data-ws-option]', this.root);
      const sel = this.selectedOptions();
      groups.forEach((fs, gi) => {
        $$('input', fs).forEach(inp => {
          const test = sel.slice(); test[gi] = inp.value;
          const ok = this.product.variants.some(v => v.available && v.options.every((o, i) => o === test[i]));
          inp.closest('.ws-chip').classList.toggle('is-unavailable', !ok);
        });
        const lbl = $('[data-ws-option-value]', fs); if (lbl) lbl.textContent = sel[gi];
      });
    }

    /* Bundles */
    initBundles() {
      this.bundleInputs = $$('[data-ws-bundle] input', this.root);
      this.bundleInputs.forEach(inp => inp.addEventListener('change', () => {
        this.qty = +inp.value; this.tierDiscount = +inp.dataset.discount || 0; this.render();
      }));
      const checked = this.bundleInputs.find(i => i.checked);
      if (checked) { this.qty = +checked.value; this.tierDiscount = +checked.dataset.discount || 0; }
    }

    /* Upsell (battery etc.) */
    initUpsell() {
      this.upsellBox = $('[data-ws-upsell]', this.root);
      if (!this.upsellBox) return;
      this.upsellCheck = $('input[type="checkbox"]', this.upsellBox);
      this.upsellSelect = $('select', this.upsellBox);
      this.upsellCheck.addEventListener('change', () => this.render());
      this.upsellSelect?.addEventListener('change', () => this.render());
      this.upsellSelect?.addEventListener('click', e => e.stopPropagation());
    }
    upsellVariant() {
      if (!this.upsellBox) return null;
      const el = this.upsellSelect ? this.upsellSelect.selectedOptions[0] : $('[data-ws-upsell-variant]', this.upsellBox);
      return { id: +el.value || +el.dataset.id, price: +el.dataset.price, compare: +el.dataset.compare || 0 };
    }

    /* Render all dynamic numbers */
    render() {
      const v = this.variant;
      const unit = v.price, cmp = v.compare_at_price && v.compare_at_price > v.price ? v.compare_at_price : 0;
      const set = (sel, txt) => $$(sel, this.root).forEach(el => el.textContent = txt);
      set('[data-ws-price]', money(unit));
      $$('[data-ws-compare]', this.root).forEach(el => { el.textContent = cmp ? money(cmp) : ''; el.hidden = !cmp; });
      $$('[data-ws-save]', this.root).forEach(el => { el.hidden = !cmp; if (cmp) el.textContent = (el.dataset.label || 'Économisez [amount]').replace('[amount]', money(cmp - unit)); });
      $$('[data-ws-discount]', this.root).forEach(el => { el.hidden = !cmp; if (cmp) el.textContent = '−' + Math.round((1 - unit / cmp) * 100) + ' %'; });
      set('[data-ws-split]', money(unit / 3));

      // bundle tiers
      $$('[data-ws-bundle] input', this.root).forEach(inp => {
        const q = +inp.value, d = +inp.dataset.discount || 0;
        const total = unit * q * (1 - d / 100);
        const card = inp.closest('[data-ws-bundle]');
        $('[data-ws-tier-total]', card).textContent = money(total);
        const was = $('[data-ws-tier-compare]', card);
        if (was) { const c = (cmp || unit) * q; was.textContent = c > total ? money(c) : ''; }
        const per = $('[data-ws-tier-unit]', card); if (per) per.textContent = money(total / q);
      });

      // upsell
      let upTotal = 0;
      if (this.upsellBox) {
        const u = this.upsellVariant();
        const q = this.cfg.upsellMatchQty ? this.qty : 1;
        set('[data-ws-upsell-price]', '+' + money(u.price * q));
        $$('[data-ws-upsell-compare]', this.root).forEach(el => el.textContent = u.compare > u.price ? money(u.compare * q) : '');
        $$('[data-ws-upsell-qty]', this.root).forEach(el => el.textContent = q > 1 ? q + ' × ' : '');
        if (this.upsellCheck.checked) upTotal = u.price * q;
      }

      if (this.qtyInput) this.qtyInput.value = this.qty;
      if (this.upIdInput && this.upsellBox) {
        const u = this.upsellVariant(), on = this.upsellCheck.checked;
        this.upIdInput.value = u.id; this.upQtyInput.value = this.cfg.upsellMatchQty ? this.qty : 1;
        this.upIdInput.disabled = this.upQtyInput.disabled = !on;
      }
      const total = unit * this.qty * (1 - this.tierDiscount / 100) + upTotal;
      set('[data-ws-total]', money(total));

      // stock + availability
      const atcs = $$('[data-ws-atc]', this.root);
      atcs.forEach(b => {
        b.disabled = !v.available;
        $$('[data-ws-atc-label]', b).forEach(l => l.textContent = v.available ? this.cfg.atcLabel : this.cfg.soldOutLabel);
      });
      const stock = $('[data-ws-stock]', this.root);
      if (stock) {
        const inv = this.cfg.inventory[v.id];
        const dot = $('.ws-dot', stock), txt = $('[data-ws-stock-text]', stock);
        dot.className = 'ws-dot';
        if (!v.available) { dot.classList.add('ws-dot--out'); txt.innerHTML = this.cfg.stockOut; }
        else if (inv != null && inv > 0 && inv <= this.cfg.lowStock) { dot.classList.add('ws-dot--low'); txt.innerHTML = this.cfg.stockLow.replace('[count]', inv); }
        else txt.innerHTML = this.cfg.stockIn;
      }
      set('[data-ws-variant-title]', v.title === 'Default Title' ? '' : v.title.replace(/ \/ /g, ' · '));
      this.markAvailability();
    }

    /* Add to cart (main item + optional upsell in one request) */
    initAtc() {
      this.error = $('[data-ws-error]', this.root);
      // Capture phase on window: runs before Impact / app listeners that would re-submit the form with quantity 1
      window.addEventListener('submit', e => {
        if (e.target !== this.form) return;
        e.preventDefault(); e.stopImmediatePropagation(); this.add();
      }, true);
      $$('[data-ws-atc]', this.root).forEach(b => b.addEventListener('click', e => {
        e.preventDefault(); e.stopImmediatePropagation(); this.add();
      }, true));
      $$('[data-ws-atc-external]').forEach(b => b.addEventListener('click', () => this.add()));
    }
    async add() {
      if (this.busy) return; this.busy = true;
      const btns = $$('[data-ws-atc]', this.root);
      btns.forEach(b => b.classList.add('is-loading'));
      this.error?.classList.remove('is-visible');
      const items = [{ id: this.variant.id, quantity: this.qty }];
      if (this.qty > 1 && this.cfg.bundleProperty) items[0].properties = { [this.cfg.bundleProperty]: this.qty + ' pièces' };
      if (this.upsellBox && this.upsellCheck.checked) {
        const u = this.upsellVariant();
        items.push({ id: u.id, quantity: this.cfg.upsellMatchQty ? this.qty : 1 });
      }
      console.info('[Warm Style] ajout au panier', items);
      try {
        const sections = this.cfg.cartSections;
        const res = await fetch(window.Shopify?.routes?.root ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items, sections, sections_url: location.pathname })
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || data.message || 'Erreur');
        this.afterAdd(data);
      } catch (err) {
        if (this.error) { this.error.textContent = err.message; this.error.classList.add('is-visible'); }
      } finally { this.busy = false; btns.forEach(b => b.classList.remove('is-loading')); }
    }
    afterAdd(data) {
      // Impact (Maestrooo) listens to cart:refresh to re-render its drawer & counters.
      window.__wsAutoOpen = false;
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      window.__wsAutoOpen = true;
      document.dispatchEvent(new CustomEvent('ws:cart:added', { detail: data }));
      if (this.cfg.afterAdd === 'cart') { location.href = (window.Shopify?.routes?.root || '/') + 'cart'; return; }
      if (this.cfg.afterAdd === 'checkout') { location.href = '/checkout'; return; }
      // Warm Style header drawer listens to ws:cart:added and opens itself
      if (document.querySelector('[data-ws-cart]')) return;
      // Otherwise open Impact's cart drawer
      const drawer = document.querySelector('cart-drawer, #cart-drawer');
      setTimeout(() => {
        if (drawer && typeof drawer.show === 'function') drawer.show();
        else if (drawer) drawer.setAttribute('open', '');
        else { const t = document.querySelector('[aria-controls="cart-drawer"]'); t ? t.click() : (location.href = '/cart'); }
      }, 150);
    }

    /* Sticky add-to-cart bar */
    initSticky() {
      this.sticky = document.getElementById('ws-sticky-' + this.cfg.sectionId);
      const anchor = $('[data-ws-buy-anchor]', this.root);
      if (!this.sticky || !anchor) return;
      document.body.appendChild(this.sticky);
      $('[data-ws-sticky-btn]', this.sticky)?.addEventListener('click', () => this.add());
      new IntersectionObserver(([e]) => {
        this.sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(anchor);
      this.stickyObserver = () => {
        const set = (s, t) => $$(s, this.sticky).forEach(el => el.textContent = t);
        set('[data-ws-total]', $('[data-ws-total]', this.root)?.textContent || '');
        set('[data-ws-variant-title]', $('[data-ws-variant-title]', this.root)?.textContent || '');
      };
      const r = this.render.bind(this);
      this.render = () => { r(); this.stickyObserver(); };
    }

    /* Countdown (offer) + shipping cut-off + delivery dates */
    initTimers() {
      const pad = n => String(n).padStart(2, '0');
      const offerEls = $$('[data-ws-countdown]');
      const endAttr = offerEls[0]?.dataset.end;
      const cut = this.cfg.cutoffHour;
      const isWeekday = d => d.getDay() !== 0 && d.getDay() !== 6;
      const addBiz = (d, n) => { const x = new Date(d); while (n > 0) { x.setDate(x.getDate() + 1); if (isWeekday(x)) n--; } return x; };
      const fmtDate = d => d.toLocaleDateString(document.documentElement.lang || 'fr-FR', { weekday: 'short', day: 'numeric', month: 'short' });
      const tick = () => {
        const now = new Date();
        // offer countdown: explicit end date, else midnight
        let end = endAttr ? new Date(endAttr) : new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
        if (end < now) end = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
        const l = end - now;
        const h = Math.floor(l / 3.6e6);
        offerEls.forEach(el => el.textContent = (h >= 24 ? Math.floor(h / 24) + 'j ' + pad(h % 24) : pad(h)) + ':' + pad(Math.floor(l / 6e4) % 60) + ':' + pad(Math.floor(l / 1000) % 60));
        // shipping
        let ship = new Date(now); ship.setHours(cut, 0, 0, 0);
        const today = isWeekday(now) && now < ship;
        if (!today) { ship = addBiz(new Date(now.getFullYear(), now.getMonth(), now.getDate()), 1); ship.setHours(cut, 0, 0, 0); }
        const sl = ship - now;
        $$('[data-ws-ship-timer]', this.root).forEach(el => el.textContent = Math.floor(sl / 3.6e6) + ' h ' + pad(Math.floor(sl / 6e4) % 60) + ' min');
        $$('[data-ws-ship-word]', this.root).forEach(el => el.textContent = today ? el.dataset.today : fmtDate(ship));
        $$('[data-ws-ship-date]', this.root).forEach(el => el.textContent = fmtDate(ship));
        $$('[data-ws-eta]', this.root).forEach(el => el.textContent = fmtDate(addBiz(ship, this.cfg.etaMin)) + ' – ' + fmtDate(addBiz(ship, this.cfg.etaMax)));
      };
      tick(); setInterval(tick, 1000);
    }

    initModals() {
      $$('[data-ws-open]', this.root).forEach(b => b.addEventListener('click', () => document.getElementById(b.dataset.wsOpen)?.showModal()));
      $$('dialog.ws-modal').forEach(d => {
        d.addEventListener('click', e => { if (e.target === d) d.close(); });
        $$('[data-ws-close]', d).forEach(b => b.addEventListener('click', () => d.close()));
      });
    }

    /* Exit intent (desktop only, once per session) */
    initExit() {
      const d = document.getElementById('ws-exit-' + this.cfg.sectionId);
      if (!d || matchMedia('(hover: none)').matches) return;
      const key = 'ws-exit-shown';
      const onLeave = e => {
        if (e.clientY > 0 || sessionStorage.getItem(key)) return;
        sessionStorage.setItem(key, '1'); d.showModal();
        document.removeEventListener('mouseout', onLeave);
      };
      setTimeout(() => document.addEventListener('mouseout', onLeave), (this.cfg.exitDelay || 8) * 1000);
    }
  }

  /* ---------------- Generic tab widgets (heat levels, audiences) ---------------- */
  function initTabs(root) {
    const tabs = $$('[role="tab"]', root), panels = $$('[role="tabpanel"]', root);
    tabs.forEach((t, i) => t.addEventListener('click', () => {
      tabs.forEach((x, j) => x.setAttribute('aria-selected', i === j));
      panels.forEach((p, j) => p.hidden = i !== j);
    }));
  }

  /* ---------------- Horizontal scroller arrows ---------------- */
  function initScroller(root) {
    const track = $('[data-ws-scroll-track]', root);
    if (!track) return;
    const step = () => (track.firstElementChild?.offsetWidth || 300) + 16;
    $('[data-ws-scroll-prev]', root)?.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    $('[data-ws-scroll-next]', root)?.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
  }

  function boot(scope = document) {
    $$('[data-ws-main]', scope).forEach(el => { if (!el.__ws) { try { el.__ws = new WsMain(el); } catch (err) { console.error('[Warm Style] erreur section produit :', err); } } });
    $$('[data-ws-tabs]', scope).forEach(el => { if (!el.__ws) { el.__ws = 1; initTabs(el); } });
    $$('[data-ws-scroller]', scope).forEach(el => { if (!el.__ws) { el.__ws = 1; initScroller(el); } });
    $$('[data-ws-scroll-top]', scope).forEach(el => { if (!el.__ws) { el.__ws = 1; el.addEventListener('click', e => { e.preventDefault(); const t = document.querySelector('[data-ws-main]'); window.scrollTo({ top: t ? t.getBoundingClientRect().top + scrollY - 80 : 0, behavior: 'smooth' }); }); } });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot()); else boot();
  // Theme editor support
  document.addEventListener('shopify:section:load', e => boot(e.target));
})();
